import React,{useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import PropTypes from 'prop-types';
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Card, CardContent,CardActions} from "@mui/material";
import { getIntlTranslation, getTranslationVariantText } from "../../../../utils/helper";
import CustomButton from "../../../../components/buttons/CustomButton";
import { saveContactUser } from "../../api/chaptersApi";

const ContactCard = (props) => {
  const openAsset = useSelector((state) => state.openAsset);
  const dispatch = useDispatch();
  const scope = useSelector((state) => state.container.scope);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if(!!props.projectInfo){
      setUsers(props.projectInfo.users);
    }
  }, [props.projectInfo])
  

  const handleContactChange = (checked,emailAddress) => {
    const temp = users.map((el) => {
      if (el.emailAddress === emailAddress) {
        el = { ...el, contact: checked };
      }
      return el;
    });
    setUsers(temp);
  };


  const onSave = () => {
    const data = {
      type: "assetContactDto",
      assetIdent: openAsset.ident,
      users: users,
    };
    dispatch(saveContactUser(data, scope.projectIdent, props.reportType));
  };

    const createAuthorCheckBox = () => {
        return users.map((el,index) => {
          return (
           
              <Card
                variant="outlined"
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  flexDirection: "column",
                  width: 300,
                  margin:5,
                  height:300,
                }}
                key={index}
              >
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ marginTop: "10px", marginBottom: "0px !important" }}
                >
                  {el.firstName + " " + el.lastName}
                </Typography>
                <CardContent style={{ padding: 5, alignSelf: "flex-start" }}>
                  <Box style={{ display: "flex" }}>
                    {!!el.position ? (
                      <Typography
                        color="text.secondary"
                        component="div"
                        style={{ marginLeft: 3 }}
                      >
                        Position : {el.position}
                      </Typography>
                    ) : (
                      <Typography color="text.secondary" component="div">
                        Position :{" "}
                        <span style={{ marginLeft: 3, color: "red" }}>
                          {getIntlTranslation("_Data is missing")}
                        </span>
                      </Typography>
                    )}
                  </Box>
                  <Box style={{ display: "flex", flexWrap: "nowrap" }}>
                    {!!el.taOfficeDto?.officeName ? (
                      <Typography
                        color="text.secondary"
                        component="div"
                        style={{ marginLeft: 3, wordBreak: "keep-all" }}
                      >
                        {getIntlTranslation("_Office Name")} : {el.taOfficeDto?.officeName}
                      </Typography>
                    ) : (
                      <Typography color="text.secondary" component="div">
                        {getIntlTranslation("_Office Name")} :{" "}
                        <span style={{ marginLeft: 3, color: "red" }}>
                          {getIntlTranslation("_Data is missing")}
                        </span>
                      </Typography>
                    )}
                  </Box>
                  <Box style={{ display: "flex" }}>
                    {!!el.emailAddress ? (
                      <Typography
                        color="text.secondary"
                        component="div"
                        style={{ marginLeft: 3 }}
                      >
                        Email : {el.emailAddress}
                      </Typography>
                    ) : (
                      <Typography color="text.secondary" component="div">
                        Email :{" "}
                        <span style={{ marginLeft: 3, color: "red" }}>
                          {getIntlTranslation("_Data is missing")}
                        </span>
                      </Typography>
                    )}
                  </Box>
                  <Box style={{ display: "flex" }}>
                    {!!el.mobile ? (
                      <Typography
                        color="text.secondary"
                        component="div"
                        style={{ marginLeft: 3 }}
                      >
                        {getIntlTranslation("_Mobile")} : {el.mobile}
                      </Typography>
                    ) : (
                      <Typography color="text.secondary" component="div">
                        {getIntlTranslation("_Mobile")} :{" "}
                        <span style={{ marginLeft: 3, color: "red" }}>
                          {getIntlTranslation("_Data is missing")}
                        </span>
                      </Typography>
                    )}
                  </Box>
                </CardContent>
                <CardActions
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    with: "99%",
                    minWidth: "99%",
                    backgroundColor: "#254a9a",
                    height:50,
                    margin:2,
                    borderRadius: 4,
                    marginTop:"auto",
                  }}
                >
                  <FormControlLabel
                    style={{
                      with: "100%",
                      color: "white",
                    }}
                    control={
                      <Checkbox
                        checked={el.contact}
                        onChange={(e) => handleContactChange(e.target.checked,el.emailAddress)}
                        name={el.emailAddress}
                        style={{
                          with: "100%",
                          color: "white",
                        }}
                      />
                    }
                    label={el.contact ? getIntlTranslation("_Remove contact") : getIntlTranslation("_Add contact")}
                  />
                </CardActions>
              </Card>
          );
        });
      };
    return (
      <>
      {users.length > 0 && 
        <Box
        className={"w-100 h-100 d-flex align-items-center"}
          >
            <Card className={"w-100 h-100 d-flex flex-column"}>
              <CardContent className={"w-100 p-1 custom-scrollBar overflow-auto"} style={{height:"calc(100% - 50px)", }}>
                   <Box
             className={"d-flex flex-wrap w-100 justify-content-start align-items-center"}
            >
                    {createAuthorCheckBox()}
                    </Box>
                </CardContent>
          <CardActions style={{ marginTop:"auto", width: "100%"}} className="d-flex flex-column">
          <span style={{ margin:"auto"}}>
                  {getTranslationVariantText("_max contact allowed", "subtitle2")}
                </span>
            <CustomButton
                  id="save-report-project-information"
                  buttonText="_save"
                  variant="button"
                  tooltip={{
                    title: getIntlTranslation("tooltip.save"),
                  }}
                  style={{
                    width: "100%",
                    margin:"auto"
                  }}
                  handleClick={onSave}
                />
            </CardActions>
            </Card>
            </Box>
}
</>
    );
};

ContactCard.propTypes = {
    users: PropTypes.arrayOf(PropTypes.object),
    onContactChange: PropTypes.func,
};

export default ContactCard;